
















































































import { Component, Vue, Prop, Ref } from "vue-property-decorator";

@Component({
    components: {
        FormBase: () => import("../../elements/forms/Base.vue"),
        FormInput: () => import("../../elements/forms/Input.vue")
    }
})
export default class EstateContact extends Vue {
    @Prop({ required: true }) whiseId!: string;

    @Prop({ required: true }) estateName!: string;

    @Prop({ required: true }) negotiator!: EstateNegotiator;

    @Ref() estateForm!: FormClass;

    payload: any = {
        estate_title: "",
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        realtor_email: "info@sophimo.be",
        message: "",
        whise_id: "",
        allow_newsletter: false
    };

    accepted_terms: boolean = false;

    isOpen: boolean = false;

    open() {
        this.isOpen = true;
        // @ts-ignore
        this.$root.disableScrolling(true);
    }

    close() {
        this.isOpen = false;
        // @ts-ignore
        this.$root.disableScrolling(false);
    }

    private submitForm() {
        this.payload.whise_id = this.whiseId;
        this.payload.realtor_email = this.negotiator.email;
        this.payload.estate_title = this.estateName;

        // @ts-ignore
        axios
            .post("/api/forms/estate-contact", this.payload)
            .then((response: any) => {
                this.estateForm.handleSuccess();
                this.payload = {
                    first_name: "",
                    last_name: "",
                    phone: "",
                    email: "",
                    message: "",
                    allow_newsletter: false
                };
                this.isOpen = false;
                this.accepted_terms = false;
            })
            .catch((e: any) => this.estateForm.handleErrors(e));
    }
}
